import { TResponseListWrapper } from "../../common/types/common";
import { TLineItemCategory } from "../../common/types/line-item-category";
import { apiClient } from "../apiClient";

export const getLineItemCategoryList = async (): Promise<TResponseListWrapper<TLineItemCategory>> => {
    return apiClient.get(`/LineItemCategory/GetAllLineItemCategories`);
};
